import React from 'react';
import './CopyClipboardIcon.css';

const CopyClipboardIcon = (text) => {
  
  const copyToClipBoard = (event) => {
    event.preventDefault();
    window.navigator.clipboard.writeText(text.value);
  };

  return (
    <i className="fa-regular fa-copy copy-icon" onClick={e => copyToClipBoard(e)}></i>
  );
};

export default CopyClipboardIcon;
